export const REDUCER_KEY = 'consent-manager';
